"use client";

import { ArrowUpRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const fallbackProjects = [{
  id: "f1",
  title: "National Retailer SEO",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_retail_seo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_retail_seo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/national_retail_seo.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f2",
  title: "Global SaaS Expansion",
  category: "International SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_seo.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_seo.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/global_saas_seo.webp-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f3",
  title: "B2B Lead Generation",
  category: "B2B SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_gen.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_gen.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/b2b_lead_gen.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f4",
  title: "Ecommerce Growth",
  category: "Ecommerce SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_growth.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_growth.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ecommerce_growth.webp-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f5",
  title: "Technical Audit Fix",
  category: "Technical SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/technical_audit.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f6",
  title: "Local Service Growth",
  category: "Local SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_seo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_seo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/local_service_seo.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f7",
  title: "AI Search Visibility",
  category: "AI Search",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/ai_search_visibility.webp-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f8",
  title: "Full Site Migration",
  category: "Technical SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/site_migration.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/site_migration.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/site_migration.webp-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f9",
  title: "Content Strategy",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/content_strategy.png-wvc-sizes",
  orientation: "horizontal"
}, {
  id: "f10",
  title: "Enterprise B2B SEO",
  category: "B2B SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/enterprise_b2b.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/enterprise_b2b.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/enterprise_b2b.webp-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f11",
  title: "Marketplace SEO",
  category: "Ecommerce SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/marketplace_seo.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/marketplace_seo.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/marketplace_seo.png-wvc-sizes",
  orientation: "vertical"
}, {
  id: "f12",
  title: "Brand Authority",
  category: "National SEO",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1762002/img/brand_authority.png-wvc-sizes",
  orientation: "horizontal"
}];
const spanClasses = ["md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]", "md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]", "md:col-span-5 aspect-[4/5]", "md:col-start-7 md:col-span-6 aspect-[16/9]", "md:col-span-7 aspect-[16/9]", "md:col-start-9 md:col-span-4 aspect-[4/5]"];
function ProjectCard({
  title,
  category,
  image,
  srcset,
  sizes,
  link,
  spanClass,
  index
}: {
  title: string;
  category: string;
  image: string;
  srcset?: string;
  sizes?: string;
  link: string;
  spanClass: string;
  index: number;
}) {
  const CardWrapper: React.ElementType = link && link !== "#" ? Link : "div";
  const wrapperProps = link && link !== "#" ? {
    to: link
  } : {};
  return <CardWrapper data-index={index} {...wrapperProps} className={`group relative block overflow-hidden rounded-lg bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-4 focus-visible:ring-offset-background ${spanClass}`}>
      <img src={image} data-wvc-srcset={srcset} data-wvc-sizes={sizes} alt={title} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover brightness-[0.68] transition-transform duration-500 ease-out group-hover:scale-[1.03] group-focus-visible:scale-[1.03]" />
      <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-background/80 via-background/20 to-transparent" />

      <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-10">
        <div className="flex justify-start">
          <Badge variant="outline" className="rounded-sm border-primary/60 bg-transparent px-3.5 py-1 text-[13px] uppercase tracking-[0.18em] text-foreground/90 backdrop-blur-sm">
            {category}
          </Badge>
        </div>

        <div className="relative">
          <h3 className="font-serif text-xl sm:text-2xl leading-[1.05] tracking-tight text-white">
            <span className="relative inline-block">
              {title}
              <span aria-hidden="true" className="absolute -bottom-1 left-0 h-[3px] w-0 origin-left rounded-lg bg-accent transition-all duration-500 ease-out group-hover:w-full group-focus-visible:w-full" />
            </span>
          </h3>

          <div className="pointer-events-none absolute right-0 bottom-0 opacity-100 translate-y-0 md:opacity-0 md:translate-y-2 md:transition-all md:duration-300 md:ease-out md:group-hover:opacity-100 md:group-hover:translate-y-0 md:group-focus-visible:opacity-100 md:group-focus-visible:translate-y-0">
            <Button asChild={false} size="sm" className="pointer-events-auto h-auto rounded-sm bg-primary px-5 py-2.5 text-xs font-medium tracking-wide text-primary-foreground hover:bg-primary/90">
              <span className="inline-flex items-center gap-1.5">
                Read Case Study
                <ArrowUpRight className="h-3.5 w-3.5" />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </CardWrapper>;
}
function ProjectsGallery() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
        {spanClasses.map((span, i) => <div key={i} data-index={i} className={`rounded-lg bg-muted/20 animate-pulse ${span}`} />)}
      </div>;
  }
  const sourceProjects = !error && posts && posts.length > 0 ? posts.slice(0, 12).map((post, i) => {
    const fallback = fallbackProjects[i];
    return {
      id: post.id,
      title: post.title || fallback.title,
      category: post.categories && post.categories[0]?.name || fallback.category,
      image: post.featuredImage || fallback.image,
      srcset: post.featuredImage ? undefined : fallback.srcset,
      sizes: post.featuredImage ? undefined : fallback.sizes,
      link: post.link || "#"
    };
  }) : fallbackProjects.map(p => ({
    id: p.id,
    title: p.title,
    category: p.category,
    image: p.image,
    srcset: p.srcset,
    sizes: p.sizes,
    link: "#"
  }));
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
      {sourceProjects.map((project, i) => <ProjectCard key={project.id} index={i} title={project.title} category={project.category} image={project.image} srcset={project.srcset} sizes={project.sizes} link={project.link} spanClass={spanClasses[i] || spanClasses[i % spanClasses.length]} />)}
    </div>;
}
export default function CaseStudies() {
  const wp_query_params = {
    post_type: "project",
    per_page: 12,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="30585" id="genuinecasestudies" className="bg-background text-foreground">
      <div className="mx-auto w-full max-w-[1440px] px-6 py-40 sm:px-10 md:py-56 lg:px-24">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-8">
          <div className="md:col-span-2">
            <span className="block text-[14px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
              Proven Results
            </span>
          </div>

          <div className="md:col-span-10">
            <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl leading-[0.96] tracking-tight text-foreground">
              Verified SEO impact.{" "}
              <span className="italic font-normal">Real</span>{" "}
              <span className="relative inline-block">
                <span className="relative z-10">growth</span>
                <svg aria-hidden="true" viewBox="0 0 300 30" preserveAspectRatio="none" className="pointer-events-none absolute inset-x-0 -bottom-2 h-[0.35em] w-full text-accent">
                  <path d="M4 18 C 40 8, 90 24, 150 14 S 260 22, 296 12" fill="none" stroke="currentColor" strokeWidth="10" strokeLinecap="round" opacity="0.95" />
                </svg>
              </span>
              <span aria-hidden="true">.</span>
            </h2>

            <p className="mt-8 max-w-2xl font-default text-base leading-relaxed text-muted-foreground md:text-lg">
              Explore my genuine case studies. Each project follows a strict
              Challenge, Strategy, Implementation, and Results framework to
              demonstrate how I deliver sustainable search growth.
            </p>
          </div>
        </div>

        <div className="mt-20 md:mt-24">
          <PostsProvider wp_query={{
          post_type: "project",
          per_page: 12,
          order: "desc",
          orderby: "date",
          status: ["publish"]
        }}>
            <ProjectsGallery />
          </PostsProvider>
        </div>
      </div>
    </section>;
}